export default class ExtraInfo {

    public type?: string = undefined;
    public start_index?: number = undefined;
    public end_index?: number = undefined;

    public assign(response: any): ExtraInfo {
        if (response) {
            for (const key in response) {
                if (response.hasOwnProperty(key) && this.hasOwnProperty(key)) {
                    (this as any)[key] = response[key];
                }
            }
        }
        return this;
    }
}
